export enum StorageKeys {
  jwtToken = 'JWT_TOKEN',
  rememberMe = 'REMEMBER_ME',
  abTests = 'AB_TEST',
  homeDiscountShown = 'HOME_DISCOUNT_SHOWN',
  checkoutSummary = 'CHECKOUT_SUMMARY',
  userCheckoutInfo = 'USER_CHECKOUT_INFO',
  promoCodeValidated = 'PROMO_CODE_VALIDATED',
}

export const GLOBAL_VARS = [
  StorageKeys.jwtToken,
  StorageKeys.rememberMe,
  StorageKeys.abTests,
  StorageKeys.homeDiscountShown,
  StorageKeys.userCheckoutInfo,
];
